import { render } from "./AjustesConsol.vue?vue&type=template&id=2ca59830&scoped=true"
import script from "./AjustesConsol.vue?vue&type=script&lang=js"
export * from "./AjustesConsol.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./AjustesConsol.vue?vue&type=style&index=1&id=2ca59830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca59830"]])

export default __exports__